"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonModal = ButtonModal;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const OverlayTrigger_1 = require("./internal/OverlayTrigger");
const utils_1 = require("../utils");
const defaultTestId_1 = require("../utils/defaultTestId");
const ContextualModal_1 = require("./internal/ContextualModal");
function ButtonModal(props) {
    const { storybookDefaultOpen, trigger, disabled, content, title } = props;
    const state = (0, react_stately_1.useMenuTriggerState)({ isOpen: storybookDefaultOpen });
    const buttonRef = (0, react_1.useRef)(null);
    const { menuTriggerProps } = (0, react_aria_1.useMenuTrigger)({ isDisabled: !!disabled }, state, buttonRef);
    const tid = (0, utils_1.useTestIds)(props, (0, OverlayTrigger_1.isTextButton)(trigger)
        ? (0, OverlayTrigger_1.labelOr)(trigger, "buttonModal")
        : (0, OverlayTrigger_1.isNavLinkButton)(trigger)
            ? (0, defaultTestId_1.defaultTestId)(trigger.navLabel)
            : (0, OverlayTrigger_1.isIconButton)(trigger)
                ? trigger.icon
                : trigger.name);
    return ((0, jsx_runtime_1.jsx)(OverlayTrigger_1.OverlayTrigger, { ...props, menuTriggerProps: menuTriggerProps, state: state, buttonRef: buttonRef, ...tid, children: (0, jsx_runtime_1.jsx)(ContextualModal_1.ContextualModal, { content: content, title: title, close: state.close }) }));
}
